import type {
	Appointment,
	AppointmentBody,
	ApplicantDetail,
	HiringLead,
	ApplicantListItem,
	ApplicantPatch,
	StartTrainingBody,
	TraineeApplicant,
	NewApplicant,
	RatingSubmission,
	ReviewDetail,
	ReviewKind,
} from '../../types/hiring'
import { API_URL, request, requestUpload } from './http'

const json = (method: string, body: unknown): RequestInit => ({ method, body: JSON.stringify(body) })

export const listApplicants = () => request<ApplicantListItem[]>('/admin/applicants')

export const getApplicant = (id: number) => request<ApplicantDetail>(`/admin/applicants/${id}`)

export const createApplicant = (body: NewApplicant) => request<ApplicantDetail>('/admin/applicants', json('POST', body))

export const updateApplicant = (id: number, body: ApplicantPatch) =>
	request<ApplicantDetail>(`/admin/applicants/${id}`, json('PATCH', body))

export const uploadApplicantCv = (id: number, file: File) => requestUpload<ApplicantDetail>(`/admin/applicants/${id}/cv`, file)

export const applicantCvUrl = (id: number) => `${API_URL}/admin/applicants/${id}/cv`

export const startReview = (applicantId: number, kind: ReviewKind) =>
	request<{ id: number }>(`/admin/applicants/${applicantId}/reviews`, json('POST', { kind }))

export const scheduleReview = (applicantId: number, kind: ReviewKind, body: AppointmentBody) =>
	request<ApplicantDetail>(`/admin/applicants/${applicantId}/reviews/${kind}/appointment`, json('PUT', body))

export const listAppointments = (from: string, to: string) => request<Appointment[]>(`/admin/applicants/appointments?from=${from}&to=${to}`)

export const listHiringLeads = () => request<HiringLead[]>('/admin/applicants/leads')

export const getReview = (id: number, isRevealRequested: boolean) =>
	request<ReviewDetail>(`/admin/applicant-reviews/${id}${isRevealRequested ? '?reveal=1' : ''}`)

export const saveReviewNote = (id: number, key: string, body: string | null) =>
	request<{ question_key: string; body: string | null }>(
		`/admin/applicant-reviews/${id}/notes/${encodeURIComponent(key)}`,
		json('PUT', { body }),
	)

export const completeReview = (id: number) => request<ReviewDetail>(`/admin/applicant-reviews/${id}/complete`, { method: 'POST' })

export const submitRating = (id: number, body: RatingSubmission) =>
	request<ReviewDetail>(`/admin/applicant-reviews/${id}/ratings`, json('POST', body))

export const revealRatings = (id: number) => request<ReviewDetail>(`/admin/applicant-reviews/${id}/reveal`, { method: 'POST' })

export const startTraining = (id: number, body: StartTrainingBody) =>
	request<TraineeApplicant>(`/admin/applicants/${id}/start-training`, json('POST', body))
